"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

require("core-js/modules/es6.object.freeze");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));

var _MenuList = _interopRequireDefault(require("@material-ui/core/MenuList"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var ALIGNMENT_MAP = Object.freeze({
  "default": Object.freeze({
    left: 'bottom-start',
    right: 'bottom-end'
  }),
  subnav: Object.freeze({
    left: 'right-start',
    right: 'left-start'
  })
});

var popperPlacement = function popperPlacement(isSubNav, alignment) {
  var subnav = isSubNav ? 'subnav' : 'default';
  var alignValue = alignment || 'left';
  return ALIGNMENT_MAP[subnav][alignValue];
};

var styles = function styles(theme) {
  return {
    paper: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.shape.borderRadius / 2,
      boxShadow: theme.shadows[9]
    },
    popper: {
      zIndex: theme.zIndex.modal + 1
    },
    subnav: {
      transform: "translateY(-".concat(theme.spacing.unit, "px)")
    }
  };
};

var Menu = function Menu(_ref) {
  var alignment = _ref.alignment,
      anchorEl = _ref.anchorEl,
      children = _ref.children,
      classes = _ref.classes,
      className = _ref.className,
      MenuListProps = _ref.MenuListProps,
      onClose = _ref.onClose,
      open = _ref.open,
      subnav = _ref.subnav,
      width = _ref.width,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["alignment", "anchorEl", "children", "classes", "className", "MenuListProps", "onClose", "open", "subnav", "width"]);
  var inlineStyles = {};

  if (width) {
    inlineStyles.width = width;
  }

  return _react["default"].createElement(_Popper["default"], (0, _extends2["default"])({
    anchorEl: anchorEl,
    className: (0, _classnames["default"])(classes.popper, className),
    onClose: onClose,
    open: open,
    placement: popperPlacement(subnav, alignment)
  }, rest), _react["default"].createElement(_Paper["default"], {
    style: inlineStyles,
    className: (0, _classnames["default"])(classes.paper, (0, _defineProperty2["default"])({}, classes.subnav, subnav), className)
  }, _react["default"].createElement(_ClickAwayListener["default"], {
    onClickAway: onClose
  }, _react["default"].createElement(_MenuList["default"], MenuListProps, children))));
};

Menu.defaultProps = {
  alignment: 'left',
  MenuListProps: {}
};
Menu.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * This controls what side the opened menu aligns itself with the anchor Menu.
   */
  alignment: _propTypes["default"].oneOf(['left', 'right']),

  /**
   * Element to anchor/attach the Menu to. Menu will render underneath the passed anchor element.
   */
  anchorEl: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),

  /**
   * Children are usually MenuItems.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes["default"].object,

  /**
   * Additional classes to apply to the element.
   */
  className: _propTypes["default"].string,

  /**
   * Properties applied to the MUI MenuList element.
   */
  MenuListProps: _propTypes["default"].object,

  /**
   * Function callback to invoke when Menu is closed.
   */
  onClose: _propTypes["default"].func.isRequired,

  /**
   * If `true`, Menu will render on the screen.
   * Usually this property is tied to some piece of state or cast the anchorEl as a boolean value: Boolean(anchorEl).
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * If `true`, the Menu will render as a subnav/nested Menu.
   * The Menu will render left or right of the anchor menu
   * instead of underneath the anchor element.
   */
  subnav: _propTypes["default"].bool,

  /**
   * A Fixed width of Menu in pixels. Ex: `200px`.
   */
  width: _propTypes["default"].string
} : {};

var _default = (0, _styles.withStyles)(styles)(Menu);

exports["default"] = _default;